import { render, staticRenderFns } from "./classStatistics.vue?vue&type=template&id=fbea043e&scoped=true"
import script from "./classStatistics.vue?vue&type=script&lang=js"
export * from "./classStatistics.vue?vue&type=script&lang=js"
import style0 from "./classStatistics.vue?vue&type=style&index=0&id=fbea043e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbea043e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbea043e')) {
      api.createRecord('fbea043e', component.options)
    } else {
      api.reload('fbea043e', component.options)
    }
    module.hot.accept("./classStatistics.vue?vue&type=template&id=fbea043e&scoped=true", function () {
      api.rerender('fbea043e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/classStatistics.vue"
export default component.exports